<template>
<div>
  <div class="head-bg-wrapper" :style="headProp.bgImageStyle">
    <div class="title-content">{{ headProp.textLine1 }}</div>
    <div class="split-line">{{ headProp.textLine2 }}</div>
    <div class="sub-title" v-for="subText in headProp.subTexts">{{ subText }}</div>
  </div>

  <div class="glory">
    <el-row>
      <el-col :span="24" class="y-title">
        <span class="title-content">{{ $t("contactus.glory.title") }}</span>
        <span class="sub-title">Make AD Smart</span>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :xs="24" :sm="24" :xl="12" class="img-wrapper">
        <img style="width: 100%;" :src="imageGlory">
      </el-col>
    </el-row>
  </div>

  <div class="contact" :style="contacts.bgImageStyle">
    <el-row>
      <el-col :span="24" class="y-title">
        <span class="title-content">{{ $t("contactus.contact.title") }}</span>
        <span class="sub-title">{{ $t("contactus.contact.subTitle") }}</span>
      </el-col>
    </el-row>
    <el-row type="flex" justify="space-around" class="three-column">
      <el-col :xs="20" :sm="6" :xl="4" class="content-wrapper" v-for="contactItem in contacts.contactItems" :key="contactItem.id">
        <div class="content-title">{{ contactItem.title }}</div>
        <div class="content-sub-wrapper" v-for="(subContentItem, index) in contactItem.subContacts" :key="'contact_' + index">
          <div>
            <img style="width:100%" :src="subContentItem.image">
          </div>
          <div class="content">{{ subContentItem.content }}</div>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>

  export default {
    data () {
      return {
        headProp: {
          bgImageStyle : {
            backgroundImage: 'url(http://sucai003.oss-cn-qingdao.aliyuncs.com/midong/midong2.png)',
          },
          textLine1 : this.$t('contactus.headProp.textLine1'),
          textLine2 : this.$t('contactus.headProp.textLine2'),
          subTexts : this.$t('contactus.headProp.subTexts'),
          subTextClass: 'sub-title2'
        },
        imageGlory: this.$t('contactus.glory.imageGlory'),
        contacts: {
          bgImageStyle : {
            backgroundImage: 'url(http://sucai003.oss-cn-qingdao.aliyuncs.com/midong/contactus/contactus.png)',
          },
          contactItems: [
            // {
            //   id: '1',
            //   title: this.$t('contactus.contact.contactItem1'),
            //   subContacts: [
            //     {
            //       image: 'http://sucai003.oss-cn-qingdao.aliyuncs.com/midong/contactus/aso_qq.jpg',
            //       content: 'QQ：2640612272'
            //     },
            //     {
            //       image: 'http://sucai003.oss-cn-qingdao.aliyuncs.com/midong/contactus/aso_wechart.jpg',
            //       content: this.$t('wechart') + '：scientist_2308'
            //     },
            //   ]
            // },
            {
              id: '2',
              title: this.$t('contactus.contact.contactItem2'),
              subContacts: [
                {
                  image: 'http://assert.yuyuetui.com/static/bd-2-qq.png',
                  content: 'QQ：798846598'
                },
                {
                  image: 'http://assert.yuyuetui.com/static/bd-2-wechat.png',
                  content: this.$t('wechart') + '：jonie007'
                },
              ]
            },
            {
              id: '3',
              title: this.$t('contactus.contact.contactItem3'),
              subContacts: [
                {
                  image: 'https://assert.yuyuetui.com/static/lADPJw1WQZOyJ_bNAe7NAe4_494_494.jpg',
                  content: 'QQ：527790796'
                },
                {
                  image: 'https://assert.yuyuetui.com/static/lADPJwKtxaVep-_NA2TNA2Q_868_868.jpg',
                  content: this.$t('wechart') + '：13322806695'
                },
              ]
            },
          ]

        }
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  @import "../../commons/style/index.scss";

  .head-bg-wrapper {
    @media (max-width: 640px) {
      height: 50rem;
      padding: 20px;
    }
    .split-line {
      font-size: $font-size-h3;
      padding: 30px;
      text-align: center;
      @media (max-width: 640px) {
        padding: 1rem;
      }
      &:before, &:after {
        content: '';
        display: inline-block;
        height: 2px;
        width: 360px;
        background: $color-text-default-white;
        vertical-align: middle;
        margin: 0 20px;
      }
    }
    .sub-title {
      padding: 0px 20px 0;
      width: 960px;
      text-indent: 20px;
      font-size: $font-size-base;
      line-height: 28px;
      letter-spacing: 1px;
      @media (max-width: 992px) {
        width: 100%;
        line-height: 1.5rem;
        padding: 1.25rem;
      }
    }
  }

  .glory {
    padding: 50px 0px;
    background-color: $color-blue-light;
    width: 100%;
    .img-wrapper {
      text-align: center;
      margin: 0 40px;
      img{
        width: 100%;
      }
    }
  }

  .contact {
    background-size: cover;
    background-repeat: no-repeat;
    background-position-x: 50%;
    background-position-y: center;
    padding: 50px 0px;
    width: 100%;
    .three-column {
      @media (max-width: 768px) {
        flex-direction: column;
      }
      .content-wrapper {
        border: solid 1px #CDDBED;
        border-radius: 10px;
        box-shadow: rgba(0, 0, 0, 0.4) 0px 0px 3px;
        background-color: rgba(255, 255, 255, 0.6);
        min-height: 400px;
        padding: 20px 20px;
        margin: 0 10px;
        text-align: center;
        @media (max-width: 768px) {
          margin: 0 auto;
        }
        .content-sub-wrapper {
          margin-top: 20px;
          .content-sub-title {
            padding: 10px;
            &:before, &:after {
              content: '';
              display: inline-block;
              height: 1px;
              width: 15px;
              background: $color-header-bg;
              vertical-align: middle;
              margin: 0 8px;
            }
          }
          .content {
            padding: 3px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/contactus/contactus.vue